export default {
      id: "oc-up-usage",
      viewBox: "0 0 1126 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-up",
      toString: function () {
        return this.url;
      }
    }